import React from 'react';
import { Header } from "../presentation/Header";
import { Footer } from '../presentation/Footer';
import { SignUpPage } from '../presentation/SignUpPage';

export const Signup = () => {
  return (
    <>
      <Header />
      <SignUpPage />
      <Footer />
    </>
  )
}